export default RAILS_ASSET_URL("/gallery-image-01.webp")
